<template>
  <div class="d-flex w-100 justify-content-between align-items-center">
    <div class="d-flex gap-2 icon-group flex-grow-1 w-100">
      <div class="d-flex gap-2 flex-grow-1">
        <span class="material-icons-round">event_available</span>
        <div class="w-100">
          <p class="mb-0">We'll send you notifications at</p>
          <small>If you don't set a time, we will send you notifications at any time.</small>
        </div>
      </div>
      <div class="p-0">
        <input
          type="time"
          class="atm-input-time"
          :max="maxTime"
          v-model="fullTimeModel"
          @input="formatTime($event.target.value)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    newVersion: {
      type: Boolean,
      default: false,
    },
    defaultNotificationDate: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      timeDay: null,
      hour: 0,
      minutes: 0,
      fullTime: this.defaultNotificationDate,
    };
  },
  computed: {
    maxTime() {
      return Number(this.TimeSelected) === 1 ? '12:00' : '11:59';
    },
    fullTimeModel: {
      get() {
        return this.fullTime;
      },
      set(value) {
        this.fullTime = value;
      },
    },
  },
  methods: {
    formatTime(time) {
      const timeSplitted = time.split(':');
      this.timeDay = timeSplitted[0] > 12 ? 'PM' : 'AM';
      this.hour = this.time === 'PM' ? timeSplitted[0] - 12 : timeSplitted[0];
      this.minutes = Number(timeSplitted[1]);
      this.$emit('formatTime', { timeDay: this.timeDay, hour: this.hour, minutes: this.minutes });
    },
  },
};
</script>
<style lang="scss" scoped>
input[type='radio']:checked + label {
  color: #d9e7fd;
  background-color: #0052a1 !important;
}
.error {
  color: red;
}
</style>
